import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type QuestionAnswersState = {
    questionAnswers: any,
    isNewSet?: boolean,
    pathBeforeRegionalInformationPostCode?: string,
    pathBeforeEmergencySupport?: string,
    pathBeforeWhichService?: string,
    pathBeforeQuestion?: string,
    lastQuestionPage?: number
};

const initialState: QuestionAnswersState = {
    questionAnswers: {},
    isNewSet: false,
    pathBeforeRegionalInformationPostCode: undefined,
    pathBeforeEmergencySupport: undefined,
    pathBeforeWhichService: undefined,
    pathBeforeQuestion: undefined,
    lastQuestionPage: undefined
};

export const questionAnswersSlice = createSlice({
    name: 'questionAnswers',
    initialState,
    reducers: {
        setQuestionAnswers: (state, action: PayloadAction<QuestionAnswersState>) => {
            if (action.payload.isNewSet) {
                state.questionAnswers = action.payload.questionAnswers;

                return;
            }

            state.questionAnswers = { ...(state.questionAnswers || {}), ...action.payload.questionAnswers };
        },
        setPathBeforeRegionalInformationPostCode: (state, action: PayloadAction<string>) => {
            state.pathBeforeRegionalInformationPostCode = action.payload;
        },
        setPathBeforeEmergencySupport: (state, action: PayloadAction<string>) => {
            state.pathBeforeEmergencySupport = action.payload;
        },
        setPathBeforeWhichService: (state, action: PayloadAction<string>) => {
            state.pathBeforeWhichService = action.payload;
        },
        setPathBeforeQuestion: (state, action: PayloadAction<string | undefined>) => {
            state.pathBeforeQuestion = action.payload;
        },
        setLastQuestionPage: (state, action: PayloadAction<number>) => {
            state.lastQuestionPage = action.payload;
        },
        clearQuestionAnswers: () => ({
            ...initialState
        })
    }
});

export const { clearQuestionAnswers, setQuestionAnswers, setPathBeforeRegionalInformationPostCode, setPathBeforeEmergencySupport, setPathBeforeWhichService, setPathBeforeQuestion, setLastQuestionPage } = questionAnswersSlice.actions;

export default questionAnswersSlice.reducer;
